import React , { useState,useEffect,useRouter }from 'react';
import { useDispatch, useSelector } from "react-redux";
import {message as messageAntd,Spin, Layout, Button, List, Modal, Table, Input, Row, Col, Card, Breadcrumb,Tooltip as AntdTooltip,Statistic } from 'antd';
import {changeMarca, globalData,chartsData} from '../actions/mainDashboard';
import {ResponsiveContainer, Treemap,Tooltip,XAxis,CartesianGrid,Bar,YAxis,BarChart,Legend,LabelList,Label,Line,LineChart,ComposedChart,Area,AreaChart,Text} from 'recharts';
import {LoadingOutlined,RightOutlined,InfoCircleOutlined,ArrowUpOutlined,ArrowDownOutlined } from '@ant-design/icons';
import { Switch, Route, NavLink,useHistory,Link,useLocation } from 'react-router-dom';
import {colorArray} from '../helpers/const'
import {formatMinCurrency} from '../helpers/formatter'
import {mesesArray} from '../helpers/const'
import moment from 'moment'

import SelectMarcas from '../components/selectMarcas'
import ItemTags from '../components/itemTags'


const { Header, Content, Footer, Sider } = Layout;

function MainDashboard(props) {

  const history = useHistory();
    const location = useLocation();
    const [modalMarcasVisible, setModalMarcasVisible] = useState(false);
    const error = useSelector(state => state.mainDashboard.error)
    const loading = useSelector(state => state.mainDashboard.loading)
    const message = useSelector(state => state.mainDashboard.message)
    const marcas = useSelector(state => state.mainDashboard.marcas)
    const nameMarca = useSelector(state => state.mainDashboard.nameMarca)
    const nameUnidad = useSelector(state => state.mainDashboard.nameUnidad)
    const mes = useSelector(state => state.mainDashboard.mes)
    const idMarca = useSelector(state => state.mainDashboard.idMarca)
    const idUnidad = useSelector(state => state.mainDashboard.idUnidad)
    const dataInventarioNuevos = useSelector(state => state.mainDashboard.dataInventarioNuevos)
    const dataInventarioSeminuevos = useSelector(state => state.mainDashboard.dataInventarioSeminuevos)
    const dataVentaNuevos = useSelector(state => state.mainDashboard.dataVentaNuevos)
    const keysVentaNuevos = useSelector(state => state.mainDashboard.keysVentaNuevos)
    const dataVentaSeminuevos = useSelector(state => state.mainDashboard.dataVentaSeminuevos)
    const keysVentaSeminuevos = useSelector(state => state.mainDashboard.keysVentaSeminuevos)
    const dataVentaServicio = useSelector(state => state.mainDashboard.dataVentaServicio)
    const dataVentaServicioPublicoLyP = useSelector(state => state.mainDashboard.dataVentaServicioPublicoLyP)
    const dataOrdenesProcesoPublico = useSelector(state => state.mainDashboard.dataOrdenesProcesoPublico)
    const dataOrdenesProcesoPublicoLyP = useSelector(state => state.mainDashboard.dataOrdenesProcesoPublicoLyP)

    const dataTipoOrdenesProcesoLyP = useSelector(state => state.mainDashboard.dataTipoOrdenesProcesoLyP)
    const dataTipoOrdenesProceso = useSelector(state => state.mainDashboard.dataTipoOrdenesProceso)
    const dataClasificacionRefacciones = useSelector(state => state.mainDashboard.dataClasificacionRefacciones)
    const dataCardClasificacionRefaciones = useSelector(state => state.mainDashboard.dataCardClasificacionRefaciones)
    const dataTemoc = useSelector(state => state.mainDashboard.dataTemoc)
    const dataTemof = useSelector(state => state.mainDashboard.dataTemof)

    const dispatch = useDispatch();

    useEffect(() => {
     dispatch(globalData()).then(()=>{
       dispatch(chartsData(null,null))
     })
    },[]);



   function onChangeFilter(idMarca,idUnidad,nameMarca,nameUnidad,mes)
   {   
      dispatch(changeMarca(idMarca,idUnidad,nameMarca,nameUnidad,mes))
      dispatch(chartsData(idMarca,idUnidad))
      setModalMarcasVisible(false)

   }
   
   const formatAxisCurrency = (value) => {
      
       return formatMinCurrency(value)
    };

  const renderCustomizedLabel = (props) => {
    const {x, y, width, height, value } = props;
    const radius = 10;
    return (
      <g>
       <Text width={100} x={x + width / 2} y={y-10} fill="#000" textAnchor="middle" dominantBaseline="middle">
         {value}
        </Text>
      </g>
    );
  };

  const renderCustomizedLabelInt = (props) => {
    const {x, y, width, height, value } = props;
    const radius = 10;
    return (
      <g>
       <Text width={100} x={x + width / 2} y={y-10} fill="#000" textAnchor="middle" dominantBaseline="middle">
         {Math.floor(value)}
        </Text>
      </g>
    );
  };

  const renderCustomizedLabelInto = (props) => {
    const {x, y, width, height, value } = props;
    const radius = 10;
    return (
      <g>
        {!isNaN(y) ? <text x={x + width / 2} y={y+10} fill="#fff" textAnchor="middle" dominantBaseline="middle">
          {height>15?value:''}
        </text>:null}
      </g>
    );
  };




  const renderCustomizedLabelCurrency = (props) => {
    const {fill, x, y, width, height, value } = props;
    const radius = 10;
   
    return (
      <g>
       <Text width={100} x={x + width / 2} y={y-10} fill={fill} textAnchor="middle" dominantBaseline="middle">
         {formatMinCurrency(value)}
        </Text>
      </g>
    );
  };

  const renderCustomizedLabelPercent = (props) => {
    const { x, y, width, height, value } = props;
    const radius = 10;
    return (
      <g>
        {!isNaN(y) ? <text x={x + width / 2} y={y+10} fill="#fff" textAnchor="middle" dominantBaseline="middle">
          {height>15?(value+'%'):''}
        </text>:null}
        
      </g>
    );
  };

  const tooltipFormater = (value, name, props)=>
  {
       let key = props.dataKey;
       value = new Intl.NumberFormat('en').format(value)

       return "$"+value + (props.payload["c"+key] ? "("+props.payload["c"+key]+")" : "")
  }

  const tooltipFormaterCurrency = (value, name, props)=>
  {
       let key = props.dataKey;
       value = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
          }).format(value)
       return value
  }


  const tooltipFormaterPercent = (value, name, props)=>
  {
       let key = props.dataKey;
       value = new Intl.NumberFormat('en').format(value)

       return "$"+value + (props.payload["c"+key] ? "("+props.payload["c"+key]+"%)" : "")
  }

  const getPercent = (value, total) => {
  const ratio = total > 0 ? value / total : 0;

    return toPercent(ratio, 2);
  };

  const renderTooltipContent = (o) => {
    const { payload, label } = o;
    if (payload) {
    const total = payload.reduce((result, entry) => result + entry.value, 0);

    return (
      <div style={{background:'white'}}>
        <p className="total">{`${label} (Total: ${total})`}</p>
        <ul className="list">
          {payload.map((entry, index) => (
            <li key={`item-${index}`} style={{ color: entry.color }}>
              {`${entry.name}: ${entry.value}(${getPercent(entry.value, total)})`}
            </li>
          ))}
        </ul>
      </div>
    );
  }else
  { return null}
  };

 const toPercent = (decimal, fixed = 0) => `${(decimal * 100).toFixed(fixed)}%`;


 const fecha = (showMes) => `${showMes?(mes>0?mesesArray[mes]:""):""} ${moment().format("YYYY")}`
 const fechaPasado =(showMes) => `${showMes?(mes>0?mesesArray[mes]:""):""} ${moment().subtract(1, 'year').format("YYYY")}`

  return (
     <Layout style={{ height: '100vh' }}> 
                           
            <SelectMarcas open={modalMarcasVisible}  onCancel={()=>setModalMarcasVisible(false)} marcas={marcas} onChangeFilter={onChangeFilter} meses={true}/>

            <Layout className="m-layout" >
                <Header className="m-header">
                    <div className="m-header-brand" onClick={()=>setModalMarcasVisible(true)}>
                          <div style={{lineHeight:"18px"}}>{nameMarca}<RightOutlined /></div>
                          <div style={{lineHeight:"16px",fontSize:"12px", fontWeight:100}}>
                          {nameUnidad+" "+(mes>0?mesesArray[mes]:"")}
                          </div>
                    </div>
                    <div className="m-header-content" style={{marginRight:"78px"}}>
                          <AntdTooltip placement="bottom" color="blue" title="Dashboard">
                            Dashboard
                              <InfoCircleOutlined style={{marginLeft:"10px"}}/>
                          </AntdTooltip>
                    </div>
                    
                </Header>
              <Content className="m-content-background" style={{paddingTop:"64px",paddingLeft:"16px",paddingRight:"16px",paddingBottom:"16px",overflowY:"scroll"}}>
                  <Spin spinning={loading} tip="Loading..." indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>
                     
                      <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px",background:"lightslategray"}}>
                          <div style={{color:'white', fontWeight: 300, fontSize: 18 }}>Ventas autos</div>
                      </div>
                     <Row>
                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}># Mensual venta de autos</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaNuevos}>
                              <Tooltip/>
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90}  domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '# Autos', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="venta" name={"Venta "+fecha(true)} fill={colorArray[1]}>
                                  <LabelList dataKey="label" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="planVenta" name="Plan" fill={colorArray[2]}>
                                  <LabelList dataKey="planVenta" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="ventaPasado" name={"Venta "+fechaPasado(true)} fill={colorArray[3]}>
                                  <LabelList dataKey="ventaPasado" content={renderCustomizedLabel} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}># Acumulado venta de autos</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaNuevos}
                          >
                              <Tooltip/>
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90} domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '# Autos', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="aventa" name="Venta 2021" fill={colorArray[1]}>
                                  <LabelList dataKey="alabel" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aplanVenta" name="Plan" fill={colorArray[2]}>
                                  <LabelList dataKey="aplanVenta" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aventaPasado" name="Venta 2020" fill={colorArray[3]}>
                                  <LabelList dataKey="aventaPasado" content={renderCustomizedLabel} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>


                       <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>$ Mensual venta de autos</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaNuevos}
                          >
                                <Tooltip formatter={tooltipFormaterCurrency}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90} tickFormatter={formatAxisCurrency}  domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '$ Ingreso', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="ventaP" name={"Venta "+fecha(true)} fill={colorArray[6]}>
                                  <LabelList dataKey="labelP" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="planVentaP" name="Plan" fill={colorArray[7]}>
                                  <LabelList dataKey="planVentaP" content={renderCustomizedLabelCurrency} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="ventaPasadoP" name={"Venta "+fechaPasado(true)} fill={colorArray[8]}>
                                  <LabelList dataKey="ventaPasadoP" content={renderCustomizedLabelCurrency} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>$ Acumulado venta de autos</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaNuevos}
                          >
                                <Tooltip formatter={tooltipFormaterCurrency}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90} tickFormatter={formatAxisCurrency} domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '$ Ingreso', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="aventaP" name="Venta 2021" fill={colorArray[6]}>
                                  <LabelList dataKey="alabelP" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aplanVentaP" name="Plan" fill={colorArray[7]}>
                                  <LabelList dataKey="aplanVentaP" content={renderCustomizedLabelCurrency} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aventaPasadoP" name="Venta 2020" fill={colorArray[8]}>
                                  <LabelList dataKey="aventaPasadoP" content={renderCustomizedLabelCurrency} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                      
                 
                    </Row>


                     <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px",background:"lightslategray"}}>
                          <div style={{color:'white', fontWeight: 300, fontSize: 18 }}>Inventario autos</div>
                      </div>
                    <Row>
                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>Nuevos</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataInventarioNuevos}
                          >
                            <Tooltip formatter={tooltipFormater}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={120} tickFormatter={formatAxisCurrency} label={{ value: '$Costo', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                            <Legend />
                            <Bar isAnimationActive={false} dataKey="valor30" name="<30" stackId="a" fill={colorArray[0]}>
                               <LabelList dataKey="cvalor30" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor3060" name="30 a 60" stackId="a" fill={colorArray[1]} >
                               <LabelList dataKey="cvalor3060" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor60120" name="60 a 120" stackId="a" fill={colorArray[2]} >
                               <LabelList dataKey="cvalor60120" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor120" name=">120" stackId="a" fill={colorArray[3]} >
                               <LabelList dataKey="cvalor120" content={renderCustomizedLabelInto} />
                            </Bar>
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>Semi Nuevos</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataInventarioSeminuevos}
                          >
                            <Tooltip formatter={tooltipFormater}  />
                            
                              <XAxis dataKey="name"/>
                              <YAxis width={120} tickFormatter={formatAxisCurrency} label={{ value: '$Costo', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                            <Legend />
                            <Bar isAnimationActive={false} dataKey="valor30" name="<30" stackId="a" fill={colorArray[0]}>
                               <LabelList dataKey="cvalor30" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor3060" name="30 a 60" stackId="a" fill={colorArray[1]} >
                               <LabelList dataKey="cvalor3060" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor60120" name="60 a 120" stackId="a" fill={colorArray[2]} >
                               <LabelList dataKey="cvalor60120" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor120" name=">120" stackId="a" fill={colorArray[3]} >
                               <LabelList dataKey="cvalor120" content={renderCustomizedLabelInto} />
                            </Bar>
                          </BarChart>

                        </ResponsiveContainer>
                       
                      </Col>
                    </Row>
                    

                    <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px",background:"lightslategray"}}>
                          <div style={{color:'white', fontWeight: 300, fontSize: 18 }}>Servicio</div>
                      </div>
                     <Row>
                       
                       <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}># Mensual venta ordenes de servicio </div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaServicio}>
                              <Tooltip/>
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90}  domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '# Ordenes de servicio', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="venta" name={"Venta "+fecha(true)} fill={colorArray[11]}>
                                  <LabelList dataKey="label" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="planVenta" name="Plan" fill={colorArray[12]}>
                                  <LabelList dataKey="planVenta" content={renderCustomizedLabelInt} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="ventaPasado" name={"Venta "+fechaPasado(true)} fill={colorArray[13]}>
                                  <LabelList dataKey="ventaPasado" content={renderCustomizedLabelInt} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}># Acumulado venta ordenes de servicio </div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaServicio}
                          >
                              <Tooltip/>
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90} domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '# Ordenes de servicio', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="aventa" name="Venta 2021" fill={colorArray[11]}>
                                  <LabelList dataKey="alabel" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aplanVenta" name="Plan" fill={colorArray[12]}>
                                  <LabelList dataKey="aplanVenta" content={renderCustomizedLabelInt} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aventaPasado" name="Venta 2020" fill={colorArray[13]}>
                                  <LabelList dataKey="aventaPasado" content={renderCustomizedLabelInt} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>


                       <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>$ Mensual venta ordenes de servicio</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaServicio}
                          >
                                <Tooltip formatter={tooltipFormaterCurrency}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90} tickFormatter={formatAxisCurrency}  domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '$ Ingreso', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="ventaP" name={"Venta "+fecha(true)} fill={colorArray[16]}>
                                  <LabelList dataKey="labelP" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="planVentaP" name="Plan" fill={colorArray[17]}>
                                  <LabelList dataKey="planVentaP" content={renderCustomizedLabelCurrency} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="ventaPasadoP" name={"Venta "+fechaPasado(true)} fill={colorArray[18]}>
                                  <LabelList dataKey="ventaPasadoP" content={renderCustomizedLabelCurrency} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>$ Acumulado venta ordenes de servicio</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaServicio}
                          >
                                <Tooltip formatter={tooltipFormaterCurrency}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90} tickFormatter={formatAxisCurrency} domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '$ Ingreso', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="aventaP" name="Venta 2021" fill={colorArray[16]}>
                                  <LabelList dataKey="alabelP" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aplanVentaP" name="Plan" fill={colorArray[17]}>
                                  <LabelList dataKey="aplanVentaP" content={renderCustomizedLabelCurrency} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aventaPasadoP" name="Venta 2020" fill={colorArray[18]}>
                                  <LabelList dataKey="aventaPasadoP" content={renderCustomizedLabelCurrency} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                                            <Col md={24}>
                      <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>TEMOF</div>
                        </div>
                      <Row justify="center" gutter={16}>
                      {
                        dataTemof.map((item,index)=>
                              {
                                  return  <Col key={index} className="m-gutter-row" md={4}>
                                              <Card>
                                                <Statistic
                                                  title={item.name}
                                                  value={"$"+Math.floor(item.temof)}
                                                  precision={0}
                                                  valueStyle={{ color:item.temof<471?'#cf1322':'#3f8600' }}
                                                  prefix={item.temof<471?<ArrowDownOutlined />:<ArrowUpOutlined />}
                                                  suffix={
                                                       <div style={{fontSize:"14px",color:"black"}}>
                                                       {
                                                         `$471(Objetivo) $${Math.floor(item.temofPasado)}(2020)`
                                                       }
                                                       </div>
                                                    }
                                                />
                                              </Card>
                                            </Col>                  
                              })
                      }
                      </Row>
                      </Col>

                       <Col md={24}>
                      <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>TEMOF</div>
                        </div>
                      <Row justify="center" gutter={16}>
                      {
                        dataTemoc.map((item,index)=>
                              {
                                  return  <Col key={index} className="m-gutter-row" md={4}>
                                              <Card>
                                                <Statistic
                                                  title={item.name}
                                                  value={"$"+Math.floor(item.temoc)}
                                                  precision={0}
                                                 valueStyle={{ color:item.temoc<530?'#cf1322':'#3f8600' }}
                                                  prefix={item.temoc<530?<ArrowDownOutlined />:<ArrowUpOutlined />}
                                                  suffix={
                                                       <div style={{fontSize:"14px",color:"black"}}>
                                                       {
                                                         `$530(Objetivo) $${Math.floor(item.temocPasado)}(2020)`
                                                       }
                                                       </div>
                                                    }
                                                />
                                              </Card>
                                            </Col>                  
                              })
                      }
                      </Row>
                      </Col>
                      

                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}># Mensual venta mano obra horas </div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaServicio}>
                              <Tooltip/>
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90}  domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '# Horas', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="ventaMoh" name={"Venta "+fecha(true)} fill={colorArray[11]}>
                                  <LabelList dataKey="labelMoh" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="planVentaMoh" name="Plan" fill={colorArray[12]}>
                                  <LabelList dataKey="planVentaMoh" content={renderCustomizedLabelInt} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="ventaMohPasado" name={"Venta "+fechaPasado(true)} fill={colorArray[13]}>
                                  <LabelList dataKey="ventaMohPasado" content={renderCustomizedLabelInt} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}># Acumulado venta mano obra horas </div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaServicio}
                          >
                              <Tooltip/>
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90} domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '# Horas', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="aventaMoh" name="Venta 2021" fill={colorArray[21]}>
                                  <LabelList dataKey="alabelMoh" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aplanVentaMoh" name="Plan" fill={colorArray[22]}>
                                  <LabelList dataKey="aplanVentaMoh" content={renderCustomizedLabelInt} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aventaMohPasado" name="Venta 2020" fill={colorArray[23]}>
                                  <LabelList dataKey="aventaMohPasado" content={renderCustomizedLabelInt} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>


                       <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>$ Mensual venta mano obra</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaServicio}
                          >
                                <Tooltip formatter={tooltipFormaterCurrency}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90} tickFormatter={formatAxisCurrency}  domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '$ Ingreso', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="ventaMohP" name={"Venta "+fecha(true)} fill={colorArray[26]}>
                                  <LabelList dataKey="labelMohP" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="planVentaMohP" name="Plan" fill={colorArray[27]}>
                                  <LabelList dataKey="planVentaMohP" content={renderCustomizedLabelCurrency} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="ventaMohPasadoP" name={"Venta "+fechaPasado(true)} fill={colorArray[28]}>
                                  <LabelList dataKey="ventaMohPasadoP" content={renderCustomizedLabelCurrency} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>$ Acumulado venta mano obra</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataVentaServicio}
                          >
                                <Tooltip formatter={tooltipFormaterCurrency}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={90} tickFormatter={formatAxisCurrency} domain={[0, dataMax => (Math.floor(dataMax * 1.2))]} label={{ value: '$ Ingreso', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                              <Legend />
                               <Bar  isAnimationActive={false} dataKey="aventaMohP" name="Venta 2021" fill={colorArray[26]}>
                                  <LabelList dataKey="alabelMohP" content={renderCustomizedLabel} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aplanVentaMohP" name="Plan" fill={colorArray[27]}>
                                  <LabelList dataKey="aplanVentaMohP" content={renderCustomizedLabelCurrency} />
                               </Bar>
                               <Bar  isAnimationActive={false} dataKey="aventaMohPasadoP" name="Venta 2020" fill={colorArray[28]}>
                                  <LabelList dataKey="aventaMohPasadoP" content={renderCustomizedLabelCurrency} />
                               </Bar>        
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>


                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>Ots en proceso publico</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataOrdenesProcesoPublico}
                          >
                            <Tooltip formatter={tooltipFormater}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={120} tickFormatter={formatAxisCurrency} label={{ value: '$Costo', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                            <Legend />
                            <Bar isAnimationActive={false} dataKey="valor3" name="<3" stackId="a" fill={colorArray[1]}>
                               <LabelList dataKey="cvalor3" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor315" name="3 a 15" stackId="a" fill={colorArray[2]} >
                               <LabelList dataKey="cvalor315" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor1530" name="15 a 30" stackId="a" fill={colorArray[3]} >
                               <LabelList dataKey="cvalor1530" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor30" name=">30" stackId="a" fill={colorArray[4]} >
                               <LabelList dataKey="cvalor30" content={renderCustomizedLabelInto} />
                            </Bar>
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>


                  
                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>Ots en proceso publico LyP</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataOrdenesProcesoPublicoLyP}
                          >
                            <Tooltip formatter={tooltipFormater}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={120} tickFormatter={formatAxisCurrency} label={{ value: '$Costo', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                            <Legend />
                            <Bar isAnimationActive={false} dataKey="valor3" name="<3" stackId="a" fill={colorArray[1]}>
                               <LabelList dataKey="cvalor3" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor315" name="3 a 15" stackId="a" fill={colorArray[2]} >
                               <LabelList dataKey="cvalor315" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor1530" name="15 a 30" stackId="a" fill={colorArray[3]} >
                               <LabelList dataKey="cvalor1530" content={renderCustomizedLabelInto} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valor30" name=">30" stackId="a" fill={colorArray[4]} >
                               <LabelList dataKey="cvalor30" content={renderCustomizedLabelInto} />
                            </Bar>
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>
                    </Row>


                    <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px",background:"lightslategray"}}>
                          <div style={{color:'white', fontWeight: 300, fontSize: 18 }}>Refacciones</div>
                      </div>
                     <Row>
                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>Clasificación inventario</div>
                        </div>
                        <ResponsiveContainer width="99%" height={400}>
                          
                          <BarChart
                            height={300}
                            data={dataClasificacionRefacciones}
                          >
                            <Tooltip formatter={tooltipFormaterPercent}  />
                             
                              <XAxis dataKey="name"/>
                              <YAxis width={120} tickFormatter={formatAxisCurrency} label={{ value: '$Costo', angle: -90, position: 'insideLeft', textAnchor: 'middle' }}/>
                            <Legend />
                            <Bar isAnimationActive={false} dataKey="valorMovimiento" name="Movimiento" stackId="a" fill={colorArray[18]}>
                               <LabelList dataKey="cvalorMovimiento" content={renderCustomizedLabelPercent} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valorNuevo" name="Nuevo" stackId="a" fill={colorArray[19]} >
                               <LabelList dataKey="cvalorNuevo" content={renderCustomizedLabelPercent} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valorTecobsoleto" name="Tec. Obsoleto" stackId="a" fill={colorArray[20]} >
                               <LabelList dataKey="cvalorTecobsoleto" content={renderCustomizedLabelPercent} />
                            </Bar>
                            <Bar isAnimationActive={false} dataKey="valorObsoleto" name="Obsoleto" stackId="a" fill={colorArray[21]} >
                               <LabelList dataKey="cvalorObsoleto" content={renderCustomizedLabelPercent} />
                            </Bar>
                          </BarChart>

                        </ResponsiveContainer>
                      </Col>

                      <Col md={12} style={{ alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center',marginBottom:"16px" }}>
                          <div style={{color:'black', fontWeight: 600, fontSize: 14 }}>Clasificación inventario</div>
                        </div>
                        <Row gutter={16}>
                          <Col className="m-gutter-row" md={8}>
                            <Card>
                              <Statistic
                                title="Total inventario refacciones"
                                value={dataCardClasificacionRefaciones?dataCardClasificacionRefaciones.valor:0}
                                precision={0}
                                valueStyle={{color:'#000000'}}
                                prefix="$"
                                suffix={null}
                              />
                            </Card>
                          </Col>
                          <Col className="m-gutter-row" md={8}>
                            <Card>
                              <Statistic
                                title="Inventario obsoleto"
                                value={dataCardClasificacionRefaciones?dataCardClasificacionRefaciones.valorObsoleto:0}
                                precision={0}
                                valueStyle={{ color: colorArray[21] }}
                                prefix="$"
                                suffix={
                                   <div style={{fontSize:"14px",color:"gray"}}>
                                   {
                                    dataCardClasificacionRefaciones?dataCardClasificacionRefaciones.cvalorObsoleto+"%":""
                                   }
                                   </div>
                                }
                              />
                            </Card>
                          </Col>
                          <Col className="m-gutter-row" md={8}>
                            <Card>
                              <Statistic
                                title="Inventario tecnicamente obsoleto"
                                value={dataCardClasificacionRefaciones?dataCardClasificacionRefaciones.valorTecobsoleto:0}
                                precision={0}
                                valueStyle={{ color: colorArray[20] }}
                                prefix="$"
                                suffix={
                                   <div style={{fontSize:"14px",color:"gray"}}>
                                   {
                                    dataCardClasificacionRefaciones?dataCardClasificacionRefaciones.cvalorTecobsoleto+"%":""
                                   }
                                   </div>
                                }
                              />
                            </Card>
                          </Col>
                        
                        </Row>
                        
                      </Col>
                       
                 
                    </Row>



                  </Spin>
              </Content>
            </Layout>
        </Layout>
    )

}


export default MainDashboard;